import { render, staticRenderFns } from "./Electronico.vue?vue&type=template&id=37043897&scoped=true&lang=pug&"
import script from "./Electronico.vue?vue&type=script&lang=js&"
export * from "./Electronico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37043897",
  null
  
)

export default component.exports